export const selectJobsReportsFilters = (state) => state?.jobsReports?.filters;
export const selectJobsReportsFilterWithValues = (state) =>
  state?.jobsReports?.filterWithvalues;

export const selectJobsReportsTimeFrame = (state) => state?.jobsReports?.time;
export const selectJobsReportsGroup = (state) => state?.jobsReports?.group;

export const selectJobsCard = (state) => state?.jobsReports?.cards;
export const selectJobsCardIsLoading = (state) =>
  state?.jobsReports?.isCardLoading;

export const selectJobsByDepartment = (state) =>
  state?.jobsReports?.jobsByDepartment;
export const selectJobsByDepartmentLoading = (state) =>
  state?.jobsReports?.isJobsByDepartmentLoading;

export const selectJobsByLocation = (state) =>
  state?.jobsReports?.jobsByLocation;
export const selectJobsByLocationLoading = (state) =>
  state?.jobsReports?.isjobsByLocationLoading;

export const selectJobsChart = (state) => state?.jobsReports?.chart;
export const selectJobsTable = (state) => state?.jobsReports?.table;
export const selectJobsChartLoading = (state) =>
  state?.jobsReports?.isChartLoading;
export const selectJobsTableLoading = (state) =>
  state?.jobsReports?.isTableLoading;
